export enum FileUploadType {
  ImportOrganizationAsset = "ImportOrganizationAsset",
  ImportDataTags = "ImportDataTags",
  ImportProject = "ImportProject",
  ImportTemplate = "ImportTemplate",
  ImportAsset = "ImportAsset",
  Generic = "Generic",
  TempRefFile= "TempRefFile"
}